// Styles
import styles from './index.module.sass';

export default function Modal({ children, modalWidth, onClose }) {
  return (
    <div className={styles.modal}>
      <div
        className={styles.modalContainer}
        style={{
          width: modalWidth || 'auto',
        }}>
        <div className={styles.modalHeader}>
          <div className={styles.closeModal}>
            <i
              className={`material-icons-outlined ${styles.cancelIcon}`}
              onClick={() => {
                if (onClose) onClose();
              }}>
              cancel
            </i>
          </div>
        </div>
        <div className={styles.childrenContainer}>{children}</div>
      </div>
    </div>
  );
}
